/*
 * @Author: Girish Akhare
 * @Date: 2021-02-09 14:11:37
 * @Last Modified by: Girish Akhare
 * @Last Modified time: 2021-04-15 17:25:17
 */
import { ViewChild } from '@angular/core';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'jhi-custom-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class CustomSelectComponent {
  @Input()
  label = '';
  @Input()
  id: string;
  @Input()
  name: string;
  @Input()
  required: boolean;
  @Input()
  list: Array<any>;
  @Input()
  selected: string;
  @Input()
  control: any;
  @Input()
  bindLabel: string;
  @Input()
  bindValue: string;
  @Input()
  minWidth: string;
  @Input()
  toolTipMessage: string;
  @Input()
  readOnly = '';
  @Output()
  change = new EventEmitter<any>();
  @Input()
  clearable: boolean;
  @ViewChild('selectDropDown', { static: true })
  selectDropDown: NgSelectComponent;
  @Input()
  placement = 'bottom';

  onChange(value: any) {
    this.change.emit(value);
  }
}
